import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { apiBase } from '../data/api';

import Hall360 from '../organisms/Hall360';
import Nav from '../organisms/Nav';
import Intro from '../pages/Intro';
import Wall from '../pages/Wall';
import WallPhoto from '../pages/WallPhoto';
import Location from '../pages/Location';
import Search from '../pages/Search';
import Info from '../pages/Info';

const routes = [
  { path: '/', name: 'Intro', Component: Intro },
  { path: '/search', name: 'Search', Component: Search },
  { path: '/info', name: 'Info', Component: Info },
  { path: '/wall', name: 'Wall', Component: Wall },
  { path: '/wall-photo', name: 'WallPhoto', Component: WallPhoto },
  { path: '/location', name: 'Location', Component: Location },
];

class Content extends Component {

  loadData = ( dispatch ) => { // needs to dispatch, so it is first argument
    return axios( {
      method: 'get',
      url: `${apiBase}/plaques.json`,
    } ).then( function ( response ) {
      dispatch( { type: 'LOAD_LOCATIONS', data: response.data } );
    } )
    .catch( function ( error ) {
      console.log( error );
    } );
  };

  componentWillMount() {
    this.loadData( this.props.dispatch ); // don't forget to pass dispatch
  }

  render() {
    return (
      <div className="Content">
        <Router basename="/hall-of-service">
          <Hall360/>
          <Nav/>
          <div className="ContentRoutes">
            {routes.map( ( { path, Component } ) => (
              <Route key={path} exact path={path}>
                {( { match, location } ) => (
                  <CSSTransition
                    in={match !== null}
                    timeout={850}
                    classNames="route"
                    unmountOnExit
                  >
                    <div className="ContentRouteHolder">
                      <Component location={location}/>
                    </div>
                  </CSSTransition>
                )}
              </Route>
            ) )}
          </div>

        </Router>
      </div>
    )
  }
}

function mapStateToProps( state ) {
  return {
    locations: state.data.locations,
  };
}

export default connect( mapStateToProps )( Content );
